import useFlags from 'hsi/hooks/useFlags';

export default function useHasQuickSearch() {
    const flags = useFlags();
    return !flags.huawei;
}
